import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { DataService_Student_PBIS } from "./shared/data.service";
import { StudentAddMeritComponent } from "./student-add-merit/student-add-merit.component";
import { StudentEditMeritComponent } from "./student-edit-merit/student-edit-merit.component";
import * as moment from "moment";

@Component({
	selector: "app-student-merit",
	templateUrl: "./student-merit.component.html",
	styleUrls: ["./student-merit.component.css"],
})
export class StudentMeritComponent implements OnInit {
	constructor(
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private PBISService: DataService_Student_PBIS,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService,
		private reportService: ReportService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadStudentPBISData();
			// this.onRefresh();
		});

		if (this.SelectedPerson != undefined) {
			this.loadStudentPBISData();
		}
	}

	ngOnChanges() {
		if (this.SelectedPerson != undefined) {
			this.loadStudentPBISData();
		}
	}

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	/////////////////////////////////////////
	// Data
	/////////////////////////////////////////

	user: any;
	SelectedPerson: any;
	private subscriptionPersonSelect: Subscription;

	//Stats and Options
	StartDate: Date = new Date();
	EndDate: Date = new Date();
	MDTotalCount: any = 0;
	MeritCount: any = 0;
	MeritPCT: any = 0;
	DemeritCount: any = 0;
	DemeritPCT: any = 0;
	TotalPointCount: any = 0; //Merit points - demerit points
	MeritPoints: any = 0;
	MeritPointPCT: any = 0;
	DemeritPoints: any = 0;
	DemeritPointPCT: any = 0;
	AllPoints: any = 0; //Merit points + demerit points
	ErrorMessage: any = "";

	isProcessing: any = false;

	//Table
	///////////////
	// Built-In
	///////////////

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedMeritPerson: any;
	lstMeritPerson: any = [];

	//Filter lists
	lstIsDemeritDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "MeritDTDesc", header: "Date/Time" },
		{ field: "MeritDesc", header: "Description" },
		{ field: "MeritValue", header: "Value" },
		{ field: "IsDemeritDesc", header: "Type" },
		{ field: "Comment", header: "Comments" },
		{ field: "ScanStation", header: "ScanStation" },
	];

	///////////////

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////
	loadStudentPBISData() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.PBISService.GetMeritPersonInfo(this.SelectedPerson.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstMeritPerson = response;

				//Init Stats
				this.MDTotalCount = 0;
				this.MeritCount = 0;
				this.MeritPCT = 0;
				this.DemeritCount = 0;
				this.DemeritPCT = 0;
				this.TotalPointCount = 0;
				this.MeritPoints = 0;
				this.MeritPointPCT = 0;
				this.DemeritPoints = 0;
				this.DemeritPointPCT = 0;
				this.AllPoints = 0;

				//Update Values
				for (var i = 0; i < this.lstMeritPerson.length; i++) {
					var next = this.lstMeritPerson[i];

					next.MeritDTDesc = moment(next.MeritDT).format("MM/DD/YYYY h:mm a");
					next.IsDemeritDesc = next.IsDemerit == 1 ? "Demerit" : "Merit";

					//Stats:
					this.MDTotalCount += 1;
					this.AllPoints += next.MeritValue;

					if (next.IsDemerit == 1) {
						this.DemeritCount += 1;
						this.TotalPointCount -= next.MeritValue;
						this.DemeritPoints += next.MeritValue;
					} else {
						this.MeritCount += 1;
						this.TotalPointCount += next.MeritValue;
						this.MeritPoints += next.MeritValue;
					}
				}

				//Stats Percentages:
				this.MeritPCT = (this.MeritCount / this.MDTotalCount) * 100;
				this.DemeritPCT = (this.DemeritCount / this.MDTotalCount) * 100;
				this.MeritPointPCT = (this.MeritPoints / this.AllPoints) * 100;
				this.DemeritPointPCT = (this.DemeritPoints / this.AllPoints) * 100;

				//Load Data Filter Lists
				this.lstIsDemeritDesc = Array.from(new Set(this.lstMeritPerson.map((item: any) => item.IsDemeritDesc))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}
	/////////////////////////////////////////

	/////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////

	onRefresh() {
		this.loadStudentPBISData();
	}

	//Custom Button Methods
	onAddMerit() {
		this.errorMessage = "";

		var ref = this.dialogService.open(StudentAddMeritComponent, {
			header: "Add Merit",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				PersonID: this.SelectedPerson.PersonID,
				StudentID: this.SelectedPerson.DesignatorID,
				StudentName: this.SelectedPerson.PersonName,
				SchoolID: this.SelectedPerson.SchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadStudentPBISData();
			}
		});
	}

	onEditMerit() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedMeritPerson == undefined) {
			this.errorMessage = "Select a merit to edit";
			return;
		}

		var ref = this.dialogService.open(StudentEditMeritComponent, {
			header: "Edit Merit",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				PersonID: this.SelectedPerson.PersonID,
				StudentID: this.SelectedPerson.DesignatorID,
				StudentName: this.SelectedPerson.PersonName,
				SchoolID: this.SelectedPerson.SchoolID,
				SelectedMeritPerson: this.SelectedMeritPerson,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadStudentPBISData();
			}
		});
	}

	onDeleteMerit() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedMeritPerson == undefined) {
			this.errorMessage = "Select a merit to delete";
			return;
		} else {
			//Confirm?
			this.confirmationService.confirm({
				key: "main",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: "Are you sure you want to delete this item?",
				header: "Delete Merit/Demerit",
				icon: "fa",
				accept: () => {
					this.FinishDelete();
				},
				reject: () => {
					return;
				},
			});
		}
	}
	FinishDelete() {
		//Call SP
		var result = this.PBISService.MeritPersonDelete(this.SelectedMeritPerson.MeritPersonID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadStudentPBISData();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Merit",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onPrintMerit() {
		var component = this;
		this.errorMessage = "";

		var strParam = "";
		this.isProcessing = true;

		//Insert Custom Parameters Here
		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: MeritType
		var MT: any = "All";
		var MTFilter = <HTMLElement>document.getElementById("IsDemeritDesc").children[0].children[0].children[0];

		if (MTFilter.innerText != "Any") {
			MT = MTFilter.innerText;
		}

		strParam += "," + MT + "|MeritType";

		var reportID = 260;

		//Add person selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, 1);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	/////////////////////////////////////////

	/////////////////////////////////////////
	// Events
	/////////////////////////////////////////
	onStartDateChange(val) {
		this.StartDate = val;

		this.loadStudentPBISData();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadStudentPBISData();
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedMeritPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectedMeritPerson = null;
	}
	onRowDblClick(MeritPerson) {
		this.SelectedMeritPerson = MeritPerson;
		this.onEditMerit();
	}

	/////////////////////////////////////////
}
